import { Divider, Grid } from "@mui/material";
import MxFormL3SelectOwnerField from "@rf-l3/form/MxFormL3Owners";

import CreateOwnersForm, {
  PayloadOwnerForm
} from "@/src-refactor/modules/shared/components/forms/create-owners-form/CreateOwnersForm";
import { memo, useEffect } from "react";
import MxFormSubTitleAndDescription from "@rf-l1/page/form/MxFormSubTitleAndDescription";
import { ownerAutoCompleteItemAdapter } from "@rf/adapters/autocomplete-items/ownerItemAdapters";
import { OwnerVerificationData } from "@/src-refactor/modules/store/qrtk/services/owners/response/owner-verifited-exits.response";
import useOwnerCheckConflict from "../../../hooks/useOwnerCheckConflict";
import { CPropertyFormKeys } from "../../../util/schemas/property-schema/propertySchema";

const OwnerFormSection = () => {
  const { showRedFlag, updateOwner, getOwners } = useOwnerCheckConflict();
  const recibePayload = (payload: PayloadOwnerForm & OwnerVerificationData) => {
    const owners = getOwners();
    if (payload.id && payload.identification) {
      const newItem = ownerAutoCompleteItemAdapter({
        name: payload.name as string,
        id: payload.id,
        identification: payload.identification,
        isConflictive: Boolean(payload.is_conflictive || 0),
        requiredConflictEvaluation: Boolean(1),
        formData: null
      });

      updateOwner([newItem, ...owners]);
    } else {
      const newItem = ownerAutoCompleteItemAdapter({
        name: payload.name as string,
        id: window.crypto.randomUUID(),
        identification: payload.number_identification,
        isConflictive: Boolean(0),
        requiredConflictEvaluation: Boolean(0),
        formData: payload
      });
      updateOwner([newItem, ...owners]);
    }
  };

  return (
    <Grid container spacing={2}>
      <MxFormSubTitleAndDescription
        label="Propietario(s)"
        description="Seleccione el o los propietarios de esta propiedad"
        isRequired
      />

      <Grid item xs={12} sm={6} lg={4}>
        <MxFormL3SelectOwnerField
          withreacthookform={1}
          placeholder="Buscar por nombre, cédula o pasaporte"
          name={CPropertyFormKeys.owners_property}
          isMultiple
          useCustomComponent={showRedFlag}
        />
      </Grid>

      <Grid item sx={{ display: { xs: "none", sm: "block" } }}>
        <Divider orientation="vertical" />
      </Grid>

      <Grid item xs={"auto"} sx={{ m: { xs: "0 auto", sm: 0 } }} maxWidth={300}>
        <CreateOwnersForm
          emitPayload={recibePayload}
          emitPayloadExist={recibePayload}
        />
      </Grid>
    </Grid>
  );
};

export default memo(OwnerFormSection);
